import type { MessageKey } from 'types/LocaleMessageKey';

export const scienceAndResearchCalloutData: {
  bulletPoints: MessageKey[];
  description: MessageKey;
  eyebrow: MessageKey;
  title: MessageKey;
} = {
  bulletPoints: [
    'science_and_research_callout_v1_b1',
    'science_and_research_callout_v1_b2',
    'science_and_research_callout_v1_b3',
  ],
  description: 'science_and_research_callout_v1_description',
  eyebrow: 'science_and_research_callout_v1_header',
  title: 'science_and_research_callout_v1_title',
};
